import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { connect, useDispatch } from "react-redux";

// ANT DESIGN IMPORTS
import { Input, Row, Typography, Card, Table, Spin, Select, Tag } from "antd";
import { ArrowDownOutlined } from "@ant-design/icons";

// PROJECT IMPORTS
import MainLayout from "../../../../components/layouts/MainLayout";
import TopContent from "../../../../components/layouts/TopContent";
import appStatic from "../../../../config/appStatic";
import appLabel from "../../../../config/appLabel";
import definedApi from "../../../../services/definedApi";
import { BOM } from "../../../../services/definedMethod";
import cnt from "../../../../services/definedConstant";
import DownloadTableButtons from "../../../../components/DownloadTableButtons";
import CustomPagination from "../../../../components/CustomPagination";
import { rightAction } from "../../../../redux/actions";

const { Text } = Typography;

const columns = [
  {
    title: (column) => (
      <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
        {"Name"}
        <div>
          <ArrowDownOutlined style={{ fontSize: 15, color: "gray" }} />
        </div>
      </div>
    ),
    dataIndex: "name",
    sorter: (a, b) => a.name.localeCompare(b.name),
  },
  {
    title: "Short Name",
    dataIndex: "shortName",
    sorter: (a, b) => a["shortName"].localeCompare(b["shortName"]),
  },
  {
    title: "Currency",
    dataIndex: "currency",
    sorter: (a, b) => a["currency"].localeCompare(b["currency"]),
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    render: (text) => {
      let bgColor = "#F9FAFB"; // default bg
      let textColor = "#344054"; // default text
      let border = "1px solid #EAECF0";

      switch (text) {
        case "Active":
          bgColor = "#ECFDF3";
          textColor = "#067647";
          border = "1px solid #ABEFC6";
          break;
        case "Inactive":
          bgColor = "#FEE4E2";
          textColor = "#B42318";
          border = "1px solid #F0ADAD";
          break;

        default:
          break;
      }

      return (
        <Tag
          style={{
            padding: "2px 12px",
            borderRadius: "16px",
            border: border,
            fontSize: "12px",
            fontWeight: 500,
            display: "inline-block",
            backgroundColor: bgColor,
            color: textColor,
            textTransform: "capitalize",
          }}
        >
          {text}
        </Tag>
      );
    },
  },
];

const productStatusOptions = [
  { value: "status", label: "All Status" },
  { value: "active", label: "Active" },
  { value: "inactive", label: "Inactive" },
];

const PRD0300 = (props) => {
  //DECLARED VARIABLES
  const { userData, rightBtn, rightAction } = props;
  const { session } = userData;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);
  const [selectedRow, setSelectedRow] = useState(null);
  const [tableCount, setTableCount] = useState("10");
  const [fixedDepositList, setFixedDepositList] = useState([]);
  const [originalList, setOriginalList] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState("active");
  const [isSearch, setIsSearch] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  useEffect(() => {
    BOM.HasPermission("READ_FIXEDDEPOSITPRODUCT") && getFixedDepositListAction(selectedStatus);
    BOM.HasPermission("CREATE_FIXEDDEPOSITPRODUCT") && rightAction(cnt.RIGHT_ADD_BTN);
  }, [selectedStatus]);

  const getFixedDepositListAction = (
    status = selectedStatus,
    offset = 0,
    limit = Number(tableCount),
  ) => {
    const params = {
      ...(status !== "status" && { status }),
      offset,
      limit,
    };
    let body = {
      session,
      params,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, definedApi.GetFixedDepositList, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
        setIsLoading(false);
      } else {
        const objList = res.pageItems;
        setTotalItems(res.totalFilteredRecords);
        let tempArray = [];

        objList.forEach((element) => {
          tempArray.push({
            key: element?.id,
            id: element?.id,
            name: element?.name ? element?.name : "-",
            shortName: element?.shortName ? element?.shortName : "-",
            currency: element?.currency ? element?.currency?.displayLabel : "-",
            status: element?.status === "active" ? "Active" : "Inactive",
          });
        });

        //Display only active records list on the table; this will change after switching from authorized to disabled and vice versa.
        // setFixedDepositList(tempArray.filter((item) => item.disabled === false));
        setFixedDepositList(tempArray);

        //keep the orginal data to use after gList is modified when change from autorise to disable
        setOriginalList(tempArray);

        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  const getCsvListData = () => {
    return new Promise((resolve, reject) => {
      const params = {
        limit: 1000,
        offset: 0,
      };
      let body = {
        session,
        params,
      };

      BOM.FetchReqAction(body, definedApi.GetFixedDepositList, (err, res) => {
        if (err) {
          reject(err);
        } else {
          const objList = res;
          let tempArray = [];

          objList.forEach((element) => {
            tempArray.push({
              key: element?.id,
              id: element?.id,
              name: element?.name ? element?.name : "-",
              shortName: element?.shortName ? element?.shortName : "-",
              currency: element?.currency ? element?.currency?.displayLabel : "-",
              active: element?.active ? "Active" : "Inactive",
            });
          });

          resolve(tempArray);
        }
      });
    });
  };

  //DECLARED METHODS
  const onSelectItemAction = (selectedRowKeys, objParam) => {
    // console.log(selectedRowKeys);
    console.log(objParam);

    //HOLD THE OBJECT SELECTED HERE
    setSelectedRow(objParam[0]);
    [
      BOM.HasPermission("READ_FIXEDDEPOSITPRODUCT") && cnt.RIGHT_DETAIL_BTN,
      BOM.HasPermission("UPDATE_FIXEDDEPOSITPRODUCT") && cnt.RIGHT_EDIT_BTN,
    ].map((item) => {
      dispatch({
        type: item,
      });
    });
  };
  function handleSearchInTable(searchKey) {
    searchKey = searchKey.target.value;

    if (!searchKey) {
      setFixedDepositList(originalList);
      setIsSearch(false);
      return;
    }
    const filterBySearch = originalList.filter(
      (item) =>
        item?.name?.toLowerCase().includes(searchKey?.toLowerCase()) ||
        item?.shortName?.toLowerCase().includes(searchKey?.toLowerCase()) ||
        item?.currency.toLowerCase()?.includes(searchKey.toLowerCase()),
    );
    setFixedDepositList(filterBySearch);
    setIsSearch(true);
  }
  function selectTableCount(value) {
    setTableCount(value);
  }
  function onRefresh(offset = 0, limit = Number(tableCount)) {
    getFixedDepositListAction(selectedStatus, offset, limit);
    setIsSearch(false);
  }
  function handleOnView() {
    // console.log(selectedRow);
    const { detailBtn } = rightBtn;
    if (detailBtn.toLowerCase() === "primary") {
      navigate("/view-prd0300", { state: selectedRow });
    } else {
      console.log("Please choose a record from the table to open");
    }
  }
  function handleOnCreate() {
    const { addBtn } = rightBtn;
    if (addBtn.toLowerCase() === "primary") {
      navigate("/add-prd0300", { ofObj: selectedRow });
    } else {
      console.log("Could not open the link");
    }
  }
  function handleOnEdit() {
    // console.log(selectedRow);
    const { editBtn } = rightBtn;
    if (editBtn.toLowerCase() === "primary") {
      navigate("/edit-prd0300", { state: selectedRow });
    } else {
      console.log("Please choose a record from the table to open");
    }
  }

  return (
    <MainLayout
      isEnableRightSidebar={true}
      onView={handleOnView}
      onAdd={handleOnCreate}
      onEdit={handleOnEdit}
    >
      <TopContent pageTitle={appLabel.FixedDeposit} pageItems={appStatic.FixedDepositItems} />

      <Card
        title={`${appLabel.FixedDeposit} List`}
        style={{
          boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
          borderRadius: 20,
        }}
      >
        {/* RENDER TABLE LIST HERE*/}
        <Spin spinning={isLoading} size="large">
          <Row style={{ marginBottom: 20 }}>
            <div style={{ marginBottom: "auto" }}>
              <Text style={{ marginRight: 8 }}>Show</Text>
              <Select
                defaultValue={tableCount}
                options={[
                  { value: "5", label: "5" },
                  { value: "10", label: "10" },
                  { value: "25", label: "25" },
                  { value: "50", label: "50" },
                ]}
                onSelect={selectTableCount}
              />
              <Text style={{ marginLeft: 8 }}>Entries</Text>
            </div>

            <div style={{ marginLeft: 10 }}>
              <Input
                onChange={handleSearchInTable}
                placeholder="Search by Name, Short Name and Currency"
                style={{
                  width: 400,
                }}
                allowClear
              />
            </div>
            <div style={{ marginBottom: "auto", marginLeft: 10 }}>
              <Select
                value={selectedStatus}
                options={productStatusOptions}
                onChange={setSelectedStatus}
                placeholder={"Select Status"}
                dropdownStyle={{ width: "250px" }}
                className="interbank-table-select"
              />
            </div>
            {/* <DownloadTableButtons
              downloadData={fixedDepositList}
              columns={columns}
              fileName={"Fixed Deposit Product List"}
              onExportClick={getCsvListData}
            /> */}
          </Row>
          <Table
            rowSelection={{
              type: "radio",
              onChange: onSelectItemAction,
            }}
            columns={columns}
            dataSource={fixedDepositList}
            bordered
            pagination={false}
          />
          {!isSearch && (
            <CustomPagination
              totalItems={totalItems}
              pageSize={Number(tableCount)}
              onPageChange={(page, offset) => onRefresh(offset)}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
            />
          )}
        </Spin>
      </Card>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = { rightAction };
export default connect(mapStateToProps, mapDispatchToProps)(PRD0300);
